export type OrderStatus =
  | 'new'
  | 'accepted'
  | 'preparing'
  | 'ready'
  | 'out_for_delivery'
  | 'delivered'
  | 'cancelled'

export type DeliveryType = 'express' | 'pickup'
export type ServiceMode = 'qr' | 'staff'

export interface Order {
  id: string
  order_number: string
  customer_name: string
  customer_phone: string
  delivery_type: DeliveryType
  address: string | null
  location_url: string | null
  payment_method: string
  subtotal: number
  express_fee: number
  total_final: number
  image_url: string
  order_text: string
  status: OrderStatus
  created_at: string
  table_number: string | null
  tracking_token?: string
  service_mode?: ServiceMode | null
}

export interface DashboardStatsData {
  ordersToday: number
  ordersLastHour: number
  salesToday: number
  averageTicket: number
}

export const ORDER_STATUSES: OrderStatus[] = [
  'new',
  'accepted',
  'preparing',
  'ready',
  'out_for_delivery',
  'delivered',
  'cancelled',
]

export const STATUS_CONFIG: Record<
  OrderStatus,
  { label: string; color: string; bg: string; dot: string }
> = {
  new: {
    label: 'Nuevo',
    color: 'text-[#00F5C9]',
    bg: 'bg-[#00F5C9]/10 border-[#00F5C9]/20',
    dot: 'bg-[#00F5C9]',
  },
  accepted: {
    label: 'Aceptado',
    color: 'text-[#00F5C9]',
    bg: 'bg-[#00F5C9]/10 border-[#00F5C9]/20',
    dot: 'bg-[#00F5C9]',
  },
  preparing: {
    label: 'Preparando',
    color: 'text-[#F2C94C]',
    bg: 'bg-[#F2C94C]/10 border-[#F2C94C]/20',
    dot: 'bg-[#F2C94C]',
  },
  ready: {
    label: 'Listo',
    color: 'text-[#22C55E]',
    bg: 'bg-[#22C55E]/10 border-[#22C55E]/20',
    dot: 'bg-[#22C55E]',
  },
  out_for_delivery: {
    label: 'En camino',
    color: 'text-[#7A5CFF]',
    bg: 'bg-[#7A5CFF]/10 border-[#7A5CFF]/20',
    dot: 'bg-[#7A5CFF]',
  },
  delivered: {
    label: 'Entregado',
    color: 'text-gray-400',
    bg: 'bg-gray-400/10 border-gray-400/20',
    dot: 'bg-gray-500',
  },
  cancelled: {
    label: 'Cancelado',
    color: 'text-[#EF4444]',
    bg: 'bg-[#EF4444]/10 border-[#EF4444]/20',
    dot: 'bg-[#EF4444]',
  },
}
